import { render, staticRenderFns } from "./messages.vue?vue&type=template&id=4f4dfd8d&scoped=true&"
import script from "./messages.vue?vue&type=script&lang=js&"
export * from "./messages.vue?vue&type=script&lang=js&"
import style0 from "./messages.vue?vue&type=style&index=0&lang=css&"
import style1 from "./messages.vue?vue&type=style&index=1&id=4f4dfd8d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f4dfd8d",
  null
  
)

export default component.exports